import { Select } from "native-base";

export default Select;